/*
 * @Author: yeyimei
 * @Date: 2023-09-22 14:05:21
 * @LastEditTime: 2023-10-20 17:11:45
 * @LastEditors: yeyimei
 * @Description:
 * @FilePath: \cardlan-h5-qrcode\src\utils\film.js
 */
import request from "./method-type.js"

//获取电影票城市列表
export const getMovieCityListApi = () => {
  return request.get("hm/movie/city/list")
}

//获取电影票热门城市列表
export const getMovieHotCityListApi = () => {
  return request.get("hm/movie/hot_city/list")
}

//获取电影票区域列表
export const getMovieAreaListApi = (cityId) => {
  return request.get(`hm/movie/area/list/${cityId}`)
}

//获取banner信息
export const getMovieBannerListApi = (data) => {
  return request.post(`hm/movie/banner/list`, data)
}

//获取电影信息分页
export const getMoviePageApi = (data) => {
  return request.post(`hm/movie/page`, data)
}

//获取影院列表
export const getMovieCinemaListApi = (data) => {
  return request.post(`hm/movie/cinema/list`, data)
}

//获取影院场次排期
export const getMovieScheduleListApi = (data) => {
  return request.post(`hm/movie/schedule/list`, data)
}

//根据电影查询日期
export const getMovieShowDateApi = (data) => {
  return request.post(`hm/movie/show/date`, data)
}

//根据电影查询影院
export const getMovieShowPageApi = (data) => {
  return request.post(`hm/movie/show/page`, data)
}

//获取电影场次座位
export const getMovieSeatListApi = (data) => {
  return request.post(`hm/movie/seat/list`, data)
}

//获取电影配置
export const getMovieConfigApi = () => {
  return request.get(`hm/movie/config`)
}

//获取影院信息
export const getMovieCinemaApi = (cinemaId) => {
  return request.get(`hm/movie/cinema/${cinemaId}`)
}

//获取电影票订单详情
export const getMovieOrderDetailApi = (orderNo) => {
  return request.get(`hm/movie/detail/${orderNo}`)
}

//电影票提交订单
export const getMovieCommitOrderApi = (data) => {
  return request.post(`hm/movie/commitOrder`, data)
}

//获取电影订单分页
export const getMovieOrderPageApi = (data) => {
  return request.post(`hm/movie/order/page`, data)
}

//获取电影详情
export const getMovieDetailApi = (filmId) => {
  return request.get(`hm/movie/film/${filmId}`)
}

//分销电影票分页
export const getDistMoviePageApi = (data) => {
  return request.post(`hm/dist/product/movie/page`, data)
}

//GPS转换百度坐标
export const geBaiduConvertApi = (data) => {
  return request.post(`hm/lbs/baidu/convert`, data)
}
